import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#041c2c] text-slate-300 border-t border-slate-800">
      {/* Main 3-Column Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-12">
          {/* Col 1: Brand & Profile */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img
                src="https://assets.auxodev.dk/assets/001da5eb-368a-49cd-a912-65694d60b551/cropped-image0-removebg-preview.png"
                alt="Akut Vikaren ApS"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Specialiseret social- og socialpsykiatrisk vikarbureau. Vi leverer fagligt kompetente og relationsstærke vikarer til døgninstitutioner, bosteder, enkeltmandsprojekter og specialskoler i Jylland og på Fyn.
            </p>
            <div className="pt-2 flex items-center gap-2 text-xs text-slate-400">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-400"></span>
              <span>Døgnåben tilgængelighed 24/7/365</span>
            </div>

            {/* Social Media Links */}
            <div className="pt-3">
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-2.5">
                Følg os på sociale medier
              </p>
              <div className="flex items-center gap-2.5">
                <a
                  href="https://www.facebook.com/Akutvikaren"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Følg Akut Vikaren på Facebook"
                  className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-[#b39366] text-slate-300 hover:text-white flex items-center justify-center transition-all duration-200 shadow-sm border border-slate-700 hover:border-[#b39366]"
                >
                  <i className="fa-brands fa-facebook-f text-sm" aria-hidden="true"></i>
                </a>
                <a
                  href="https://www.instagram.com/akutvikaren"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Følg Akut Vikaren på Instagram"
                  className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-[#b39366] text-slate-300 hover:text-white flex items-center justify-center transition-all duration-200 shadow-sm border border-slate-700 hover:border-[#b39366]"
                >
                  <i className="fa-brands fa-instagram text-sm" aria-hidden="true"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/akut-vikaren-aps/?originalSubdomain=dk"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Følg Akut Vikaren på LinkedIn"
                  className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-[#b39366] text-slate-300 hover:text-white flex items-center justify-center transition-all duration-200 shadow-sm border border-slate-700 hover:border-[#b39366]"
                >
                  <i className="fa-brands fa-linkedin-in text-sm" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Col 2: Navigation & Services */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-base tracking-wide border-b border-slate-800 pb-2">
              Hvad kan vi hjælpe med?
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/"
                  className="text-slate-300 hover:text-[#b39366] transition-colors inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-chevron-right text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/bostotte"
                  className="text-slate-300 hover:text-[#b39366] transition-colors inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-chevron-right text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span>Bostøtte</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/aflastning"
                  className="text-slate-300 hover:text-[#b39366] transition-colors inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-chevron-right text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span>Aflastning – hjemme og ude</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/akut-anbringelse"
                  className="text-slate-300 hover:text-[#b39366] transition-colors inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-chevron-right text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span>Akut anbringelse</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/bliv-vikar"
                  className="text-slate-300 hover:text-[#b39366] transition-colors inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-chevron-right text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span>Bliv vikar</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="text-slate-300 hover:text-[#b39366] transition-colors inline-flex items-center gap-2"
                >
                  <i className="fa-solid fa-chevron-right text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span>Kontakt os</span>
                </Link>
              </li>
            </ul>

            {/* Vikar note in Col 2 */}
            <div className="pt-2">
              <Link
                to="/bliv-vikar"
                className="block p-3 rounded-lg bg-slate-800/80 border border-slate-700/80 hover:border-[#b39366] transition-colors group"
              >
                <p className="text-xs font-bold uppercase tracking-wider text-[#b39366] mb-1">
                  Søger du vikarjob?
                </p>
                <p className="text-xs text-slate-300 line-clamp-3 group-hover:text-white transition-colors">
                  Vi ansætter social og sundheds faglige uddannet medarbejder eller personer med minimum tre års relevant erhvervs erfaring ..
                </p>
                <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-[#b39366] mt-2 group-hover:translate-x-1 transition-transform">
                  <span>Læs mere om faggrupper</span>
                  <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true"></i>
                </span>
              </Link>
            </div>
          </div>

          {/* Col 3: Contact Details */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold text-base tracking-wide border-b border-slate-800 pb-2">
              Kontakt information
            </h4>
            <div className="space-y-3 text-sm">
              <div className="text-slate-300">
                <p className="font-semibold text-white">Akut Vikaren ApS</p>
                <p className="text-slate-400">Alphavej 17, 8270 Højbjerg</p>
              </div>

              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">Telefon</p>
                <a
                  href="tel:+4523964042"
                  className="text-white hover:text-[#b39366] font-semibold transition-colors inline-flex items-center gap-2 mt-0.5 whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span className="whitespace-nowrap">(+45) 23 96 40 42</span>
                </a>
              </div>

              <div>
                <p className="text-xs font-medium text-slate-500 uppercase tracking-wider">Email</p>
                <a
                  href="mailto:kontakt@akutvikaren.dk"
                  className="text-white hover:text-[#b39366] transition-colors inline-flex items-center gap-2 mt-0.5 whitespace-nowrap"
                >
                  <i className="fa-solid fa-envelope text-xs text-[#b39366]" aria-hidden="true"></i>
                  <span className="whitespace-nowrap">kontakt@akutvikaren.dk</span>
                </a>
              </div>

              <div className="pt-1">
                <a
                  href="https://maps.app.goo.gl/CGnJQRshRRNBUviN6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-xs font-medium text-[#b39366] hover:text-[#c49d68] transition-colors"
                >
                  <i className="fa-solid fa-location-dot" aria-hidden="true"></i>
                  <span>Find vej på Google Maps</span>
                  <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800/80 py-6 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500 text-center sm:text-left">
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
            <p>© {currentYear} Akut Vikaren ApS. Alle rettigheder forbeholdes.</p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.iubenda.com/privacy-policy/24875601"
                className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors"
                title="Privatlivspolitik "
              >
                Privatlivspolitik
              </a>
              <span>•</span>
              <a
                href="https://www.iubenda.com/privacy-policy/24875601/cookie-policy"
                className="iubenda-white iubenda-noiframe iubenda-embed hover:text-white transition-colors"
                title="Cookiepolitik "
              >
                Cookiepolitik
              </a>
            </div>
          </div>
          <p className="text-slate-400">Social- og socialpsykiatrisk vikarbureau i Jylland og på Fyn</p>
        </div>
      </div>
    </footer>
  );
}
